export const IhtTypeEnum = Object.freeze({
    AIM: 'AIM',
    ASSET: 'ASSET'
});

export default IhtTypeEnum;
